<template>
  <div>
      <div class="text-left mt-5">
          <b-row>
              <b-col>
                  <h5 class="text-primary">
                      <b>Notification Template For Paxel Market</b>
                  </h5>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card>
                        <h6 class="text-primary">
                            <b>Pending Payment</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                <b-form-checkbox v-model="to_seller_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                <b-form-checkbox v-model="to_buyer_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card>
                        <h6 class="text-primary">
                            <b>Processing</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                <b-form-checkbox v-model="to_seller_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                <b-form-checkbox v-model="to_buyer_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card>
                        <h6 class="text-primary">
                            <b>Confirmation Order</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                <b-form-checkbox v-model="to_seller_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                <b-form-checkbox v-model="to_buyer_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card>
                        <h6 class="text-primary">
                            <b>On Shipment</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                <b-form-checkbox v-model="to_seller_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                <b-form-checkbox v-model="to_buyer_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row class="mt-5">
              <b-col>
                  <b-card>
                        <h6 class="text-primary">
                            <b>Completed</b>
                        </h6>
                        <br>
                        <b-row>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Seller</b></label>
                                <b-form-checkbox v-model="to_seller_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6">
                                <b-form inline>
                                <label class="mr-sm-2" for="inline-form-custom-select-pref"><b>To Buyer</b></label>
                                <b-form-checkbox v-model="to_buyer_payment" name="check-button" switch>
                                    <div v-if="to_seller_payment" class="text-primary">
                                        Enabled
                                    </div>
                                    <div v-else style="color:#C4C7CA">
                                        Disabled
                                    </div>
                                </b-form-checkbox>
                                </b-form>
                                <b-form-group id="input-group-3" label="Message (Bahasa)" label-for="input-3" class="mt-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_bahasa"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <b-form-group id="input-group-3" label="Message (English)" label-for="input-3">
                                    <b-form-select
                                    id="input-3"
                                    v-model="message_payment_seller_english"
                                    :options="foods"
                                    required
                                    ></b-form-select>
                                </b-form-group>
                                <br>
                                <b-row>
                                    <b-col md="4">
                                        <b-form inline>
                                            <label class="mr-sm-2" for="inline-form-custom-select-pref">Send Message</label>
                                            <b-form-input
                                            id="input-1"
                                            type="number"
                                            value="0"
                                            style="width:55px"
                                            ></b-form-input> 
                                        </b-form>
                                    </b-col>
                                    <b-col md="3">
                                        <b-form-select
                                        id="input-3"
                                        :value="null"
                                        :options="foods"
                                        required
                                        >
                                        <b-form-select-option :value="null">Minute(s)</b-form-select-option>
                                        </b-form-select>
                                    </b-col>
                                    <b-col style="align-self:center">after confirmed action</b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                  </b-card>
              </b-col>
          </b-row>
          <b-row>
              <b-col md="6"></b-col>
              <b-col md="3">
                  <b-button block size="lg" variant="outline-primary" class="my-4">Cancel</b-button>
              </b-col>
              <b-col md="3">
                  <b-button block size="lg" variant="primary" class="my-4">Save</b-button>
              </b-col>
          </b-row>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            to_seller_payment:false,
            to_buyer_payment:false,
        }
    },
}
</script>

<style>

</style>